import { Component, Input, ViewEncapsulation } from "@angular/core";
import { AuthService } from "src/app/services/auth.service";
import { CompanyService } from "src/app/services/company.service";

import { StorageService } from "../../services/storage.service";

@Component({
  selector: "company-select",
  templateUrl: "./company-select.component.html",
  styleUrls: ["./company-select.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CompanySelectComponent {
  @Input() class: string;
  @Input() placeholder: string = "Select item";

  constructor(
    public companyService: CompanyService,
    public storage: StorageService,
    public authService: AuthService,
  ) {}
}
